<template>
  <div class="mt-5">
    <form @submit.prevent="saveData()">
      <div class="content-form-examen mb-5">
        <div class="d-flex justify-content-between">
          <div v-if="record?.header_file?.storage_path">
            <a
              :href="record?.header_file?.url"
              target="_blank"
              class="download-template-pdf"
              >Descargar imagen</a
            >
          </div>
          <div v-if="imageCodeHabilitation">
            <img :src="imageCodeHabilitation" alt="" />
          </div>
          <div v-if="!isDisabled">
            <UploadFilePhoto
              label="Adjunta el archivo de CÓDIGO DE HABILITACIÓN"
              id="filePhoto1"
              @uploadFile="(value) => uploadFileCodeHabitation(value)"
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Información personal del paciente</div>
        <div class="row mt-5">
          <div class="col-md-4 mb-5">
            <Input
              label="Nombre del paciente"
              name="namePatient"
              :value="employee.name"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Tipo Doc"
              name="typeIdentification"
              :value="employee.typeIdentification"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Sexo"
              name="gender"
              :value="employee.gender"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Documento"
              name="identification"
              :value="employee.identification"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Dirección"
              name="address"
              :value="formData.address"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.address = event.target.value)"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Date
              label="Fecha nacimiento"
              name="birthdate"
              :value="employee.birthdate"
              :required="false"
              :disabled="true"
              v-model="employee.birthdate"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Municipio"
              name="municipality"
              :value="employee.municipality"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Edad"
              name="age"
              :value="employee.age"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Nivel Educativo"
              name="education_level"
              :value="formData.education_level"
              :required="true"
              :disabled="isDisabled"
              @input="
                (event) => (formData.education_level = event.target.value)
              "
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Teléfono"
              name="phone"
              :value="formData.phone"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.phone = event.target.value)"
            />
          </div>
          <div class="col-md-4">
            <Input
              label="Estado civil"
              name="civil_status"
              :value="formData.civil_status"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.civil_status = event.target.value)"
            />
          </div>
          <div class="col-md-4">
            <Input
              label="Ocupación"
              name="occupation"
              :value="employee.occupation"
              :required="false"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Diagnóstico principal y Relacionado</div>
        <div class="row mt-5">
          <div class="col-md-3 mb-5">
            <Select
              label="Diagnóstico"
              name="diagnostic_id"
              v-model="formData.diagnostic_id"
              :options="diagnostics"
              :value="formData.diagnostic_id"
              :required="true"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-md-3 mb-5" v-if="formData.diagnostic_id">
            <Input
              label="Fecha y Hora registro de diagnóstico"
              name="dateDiagnostic"
              :value="formData.diagnostic_id?.created_at"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-3" v-if="formData.diagnostic_id?.last_claim">
            <Input
              label="Siniestro"
              name="claim"
              :value="formData.diagnostic_id?.last_claim"
              :required="false"
              :disabled="true"
            />
          </div>
          <div class="col-md-3 mb-5">
            <Select
              label="Tipo de diagnóstico"
              name="diagnostic_type"
              v-model="formData.diagnostic_type"
              :options="typeDiagnostics"
              :value="formData.diagnostic_type"
              :required="true"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-md-12 mb-5">
            <Textarea
              label="Observación del diagnóstico principal"
              name="diagnostic_observation"
              placeholder="Escribe aquí tus observaciones"
              :required="true"
              :rows="'5'"
              :value="formData.diagnostic_observation"
              :disabled="isDisabled"
              @input="
                (event) =>
                  (formData.diagnostic_observation = event.target.value)
              "
            />
          </div>
          <div class="col-md-12">
            <Textarea
              label="Condiciones de salida"
              name="departure_conditions"
              placeholder="Escribe aquí las condiciones de salida"
              :rows="'5'"
              :value="formData.departure_conditions"
              :required="true"
              :disabled="isDisabled"
              @input="
                (event) => (formData.departure_conditions = event.target.value)
              "
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Datos de ingreso</div>
        <div class="row mt-5">
          <div class="col-md-12 mb-5">
            <Input
              label="Motivo de Consulta "
              name="consult_reason"
              :value="formData.consult_reason"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.consult_reason = event.target.value)"
            />
          </div>
          <div class="col-md-12">
            <Textarea
              label="Enfermedad actual"
              name="current_disease"
              placeholder="Escribe aquí tus observaciones"
              :required="true"
              :rows="'5'"
              :value="formData.current_disease"
              :disabled="isDisabled"
              @input="
                (event) => (formData.current_disease = event.target.value)
              "
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Antecedentes personales</div>
        <div class="row mt-5">
          <div class="col-md-4 mb-5">
            <Select
              label="Hipertensión"
              name="hypertension"
              v-model="formData.hypertension"
              :options="options"
              :value="formData.hypertension"
              :required="true"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Select
              label="Asma"
              name="asthma"
              v-model="formData.asthma"
              :options="options"
              :value="formData.asthma"
              :required="true"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Select
              label="Esquema adecuado para la edad"
              name="age_appropriate"
              v-model="formData.age_appropriate"
              :options="options"
              :value="formData.age_appropriate"
              :required="true"
              :disabled="isDisabled"
            />
          </div>
          <div class="col-md-4 mb-5">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Alergias"
                  name="allergies"
                  v-model="formData.allergies.has"
                  :options="options"
                  :value="formData.allergies.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div
                class="col-md-12"
                v-if="formData?.allergies?.has?.id === '1'"
              >
                <Textarea
                  label="Alergias"
                  name="allergiesDescription"
                  placeholder="Escribe aquí las alergias"
                  :rows="'3'"
                  :required="true"
                  :value="formData.allergies.description"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.allergies.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Enfermedades"
                  name="diseases"
                  v-model="formData.diseases.has"
                  :options="options"
                  :value="formData.diseases.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div class="col-md-12" v-if="formData.diseases.has?.id === '1'">
                <Textarea
                  label="Enfermedades"
                  name="diseasesDescription"
                  placeholder="Escribe aquí las enfermedades"
                  :rows="'3'"
                  :required="true"
                  :value="formData.diseases.description"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.diseases.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Hábitos"
                  name="habits"
                  v-model="formData.habits.has"
                  :options="options"
                  :value="formData.habits.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div class="col-md-12" v-if="formData.habits.has?.id === '1'">
                <Textarea
                  label="Hábitos"
                  name="habitsDescription"
                  placeholder="Escribe aquí las hábitos"
                  :rows="'3'"
                  :required="true"
                  :value="formData.habits.description"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.habits.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Cirugías "
                  name="surgeries"
                  v-model="formData.surgeries.has"
                  :options="options"
                  :value="formData.surgeries.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div class="col-md-12" v-if="formData.surgeries.has?.id === '1'">
                <Textarea
                  label="Cirugías "
                  name="surgeriesDescription"
                  placeholder="Escribe aquí las cirugías "
                  :rows="'3'"
                  :value="formData.surgeries.description"
                  :required="true"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.surgeries.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-5">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Inmunización"
                  name="immunization"
                  v-model="formData.immunization.has"
                  :options="options"
                  :value="formData.immunization.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div
                class="col-md-12"
                v-if="formData.immunization.has?.id === '1'"
              >
                <Textarea
                  label="Inmunización"
                  name="immunizationDescription"
                  placeholder="Escribe aquí las inmunización"
                  :rows="'3'"
                  :value="formData.immunization.description"
                  :required="true"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.immunization.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <Textarea
              label="Observaciones"
              name="observations"
              placeholder="Escribe aquí tus observaciones"
              :rows="'5'"
              :value="formData.observations"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.observations = event.target.value)"
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Resumen de evolución</div>
        <div class="row mt-5">
          <div class="col-md-12">
            <Textarea
              label="Resumen de Evolución"
              name="evolution_summary"
              placeholder="Escribe aquí el resumen de evolución"
              :rows="'5'"
              :value="formData.evolution_summary"
              :required="true"
              :disabled="isDisabled"
              @input="
                (event) => (formData.evolution_summary = event.target.value)
              "
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Evolución médica</div>
        <div class="row mt-5">
          <div class="col-md-4 mb-5">
            <Input
              label="Nombre del médico"
              name="doctor_name"
              :value="formData.doctor_name"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.doctor_name = event.target.value)"
            />
          </div>
          <div class="col-md-4 mb-5">
            <Input
              label="Registro médico"
              name="medical_record"
              :value="formData.medical_record"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.medical_record = event.target.value)"
            />
          </div>
          <div></div>
          <div class="col-md-12 mb-5">
            <div class="d-flex justify-content-between">
              <div v-if="record?.medical_signature?.storage_path">
                <a
                  :href="record?.medical_signature?.url"
                  target="_blank"
                  class="download-template-pdf"
                  >Descargar firma</a
                >
              </div>
              <div v-if="imageFirma1">
                <img :src="imageFirma1" alt="" />
              </div>
              <div v-if="!isDisabled">
                <UploadFilePhoto
                  label="Adjunta imagen de tu firma"
                  id="filePhoto2"
                  @uploadFile="(value) => uploadFileSignature1(value)"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 mb-5">
            <Textarea
              label="Conducta"
              name="conduct"
              placeholder="Escribe aquí la conducta"
              :rows="'5'"
              :value="formData.conduct"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.conduct = event.target.value)"
            />
          </div>
          <div class="col-md-12">
            <Textarea
              label="Plan de manejo"
              name="medical_plan"
              placeholder="Escribe aquí el plan de manejo"
              :rows="'5'"
              :value="formData.medical_plan"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.medical_plan = event.target.value)"
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Ordenes y Remisiones</div>
        <div class="row mt-5">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Ordenes"
                  name="orders"
                  v-model="formData.orders.has"
                  :options="options"
                  :value="formData.orders.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div class="col-md-12" v-if="formData.orders.has?.id === '1'">
                <Textarea
                  label="Ordenes"
                  name="ordersDescription"
                  placeholder="Escribe aquí las ordenes"
                  :rows="'3'"
                  :value="formData.orders.description"
                  :required="true"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.orders.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12 mb-5">
                <Select
                  label="Remisiones"
                  name="referrals"
                  v-model="formData.referrals.has"
                  :options="options"
                  :value="formData.referrals.has"
                  :required="true"
                  :disabled="isDisabled"
                />
              </div>
              <div class="col-md-12" v-if="formData.referrals.has?.id === '1'">
                <Textarea
                  label="Remisiones"
                  name="referralsDescription"
                  placeholder="Escribe aquí las remisiones"
                  :rows="'3'"
                  :required="true"
                  :value="formData.referrals.description"
                  :disabled="isDisabled"
                  @input="
                    (event) =>
                      (formData.referrals.description = event.target.value)
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="header">Recomendaciones generales</div>
        <div class="row mt-5">
          <div class="col-md-12">
            <Textarea
              label="Recomendaciones generales"
              name="general_recommendations"
              placeholder="Escribe aquí las recomendaciones generales"
              :rows="'5'"
              :value="formData.general_recommendations"
              :required="true"
              :disabled="isDisabled"
              @input="
                (event) =>
                  (formData.general_recommendations = event.target.value)
              "
            />
          </div>
        </div>
      </div>
      <div class="content-form-examen mb-5">
        <div class="row mt-5">
          <div class="col-md-4">
            <Input
              label="Nombre del médico"
              name="doctor_name2"
              :value="formData.doctor_name2"
              :required="true"
              :disabled="isDisabled"
              @input="(event) => (formData.doctor_name2 = event.target.value)"
            />
          </div>
          <div class="col-md-4">
            <Input
              label="Registro médico"
              name="medical_record2"
              :value="formData.medical_record2"
              :required="true"
              :disabled="isDisabled"
              @input="
                (event) => (formData.medical_record2 = event.target.value)
              "
            />
          </div>
          <div class="col-md-12 mt-5">
            <div class="d-flex justify-content-between">
              <div v-if="record?.medical_signature?.storage_path">
                <a
                  :href="record?.medical_signature?.url"
                  target="_blank"
                  class="download-template-pdf"
                  >Descargar firma</a
                >
              </div>
              <div v-if="imageFirma2">
                <img :src="imageFirma2" alt="" />
              </div>
              <div v-if="!isDisabled">
                <UploadFilePhoto
                  label="Adjunta imagen de tu firma"
                  id="filePhoto3"
                  @uploadFile="(value) => uploadFileSignature2(value)"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-3" v-if="record">
            <div class="d-flex justify-content-between">
              <button
                @click.prevent="downloadPdf()"
                class="download-template-pdf"
              >
                Descargar examen en pdf
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mb-4" v-if="!isDisabled">
        <button
          class="button_primary"
          type="submit"
          :disabled="isBusy || $v.$invalid"
        >
          <b-spinner v-if="isBusy" />
          Guardar
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  getDiagnostcByUser,
  getEmployee,
  saveHealthCondition,
  saveFiles,
} from "@/services/health-tracker/saludCondition/service";
import { getInfoSelect } from "@/services/health-tracker/diagnostic/service";
import useInputs from "@/components/general/Inputs";
import UploadFilePhoto from "../UploadFilePhoto.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
const { Input, Textarea, Select, Date } = useInputs();
const { required } = require("vuelidate/lib/validators");

export default {
  components: {
    UploadFilePhoto,
    Input,
    Textarea,
    Select,
    Date,
    OverlayButton,
  },
  props: {
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    const me = this;
    return {
      formData: {
        employee_id: null,
        address: "",
        education_level: "",
        civil_status: "",
        phone: "",
        diagnostic_id: null,
        diagnostic_type: null,
        diagnostic_observation: "",
        departure_conditions: "",
        consult_reason: "",
        current_disease: "",
        hypertension: null,
        asthma: null,
        observations: "",
        evolution_summary: "",
        doctor_name: "",
        medical_record: "",
        doctor_name2: "",
        medical_record2: "",
        medical_signature: null,
        medical_signature2: null,
        header_file: null,
        conduct: "",
        medical_plan: "",
        general_recommendations: "",
        age_appropriate: null,
        allergies: {
          has: null,
          description: "",
        },
        diseases: {
          has: null,
          description: "",
        },
        habits: {
          has: null,
          description: "",
        },
        surgeries: {
          has: null,
          description: "",
        },
        immunization: {
          has: null,
          description: "",
        },
        orders: {
          has: null,
          description: "",
        },
        referrals: {
          has: null,
          description: "",
        },
      },
      employee: {
        name: "",
        typeIdentification: "",
        gender: "",
        identification: "",
        birthdate: "",
        age: "",
        occupation: "",
        siniestro: "",
        municipality: "",
      },
      options: [
        {
          id: "1",
          name: "Si",
        },
        {
          id: "2",
          name: "No",
        },
      ],
      claims: [],
      typeDiagnostics: [],
      imageCodeHabilitation: null,
      imageFirma1: null,
      imageFirma2: null,
      diagnostics: [],
      dateDiagnostic: null,
      id: me.$route.params.id,
      type: me.$route.params.type,
      category: me.$route.params.category,
      isBusy: false,
    };
  },
  watch: {
    record() {
      const me = this;
      if (me.record) {
        const option1 = {
          id: "1",
          name: "Si",
        };
        const option2 = {
          id: "2",
          name: "No",
        };
        me.formData = {
          ...me.formData,
          ...me.record,
          doctor_name2: me.record?.doctor_name,
          medical_record2: me.record?.medical_record,
          age_appropriate:
            me.record?.age_appropriate == "Si" ? option1 : option2,
          asthma: me.record?.asthma == "Si" ? option1 : option2,
          hypertension: me.record?.hypertension == "Si" ? option1 : option2,
          allergies: {
            has: me.record?.allergies?.has == "Si" ? option1 : option2,
            description: me.record?.allergies?.description,
          },
          diseases: {
            has: me.record?.diseases?.has == "Si" ? option1 : option2,
            description: me.record?.diseases?.description,
          },
          habits: {
            has: me.record?.habits?.has == "Si" ? option1 : option2,
            description: me.record?.habits?.description,
          },
          orders: {
            has: me.record?.orders?.has == "Si" ? option1 : option2,
            description: me.record?.orders?.description,
          },
          referrals: {
            has: me.record?.referrals?.has == "Si" ? option1 : option2,
            description: me.record?.referrals?.description,
          },
          immunization: {
            has: me.record?.immunization?.has == "Si" ? option1 : option2,
            description: me.record?.immunization?.description,
          },
          surgeries: {
            has: me.record?.surgeries?.has == "Si" ? option1 : option2,
            description: me.record?.surgeries?.description,
          },
        };
        if (me.record) {
          const option = me.diagnostics.find(
            (x) => x.id == me.record?.diagnostic_id
          );
          if (option) {
            me.formData.diagnostic_id = option;
          }

          const option2 = me.typeDiagnostics.find(
            (x) => x.id == me.record?.diagnostic_type
          );
          if (option2) {
            me.formData.diagnostic_type = option2;
          }
        }
      }
    },
  },
  computed: {
    isDisabled() {
      const me = this;
      return me.id ? true : false;
    },
  },
  validations: {
    formData: {
      address: {
        required,
      },
      education_level: {
        required,
      },
      civil_status: {
        required,
      },
      phone: {
        required,
      },
      diagnostic_type: {
        required,
      },
      diagnostic_observation: {
        required,
      },
      departure_conditions: {
        required,
      },
      consult_reason: {
        required,
      },
      current_disease: {
        required,
      },
      hypertension: {
        required,
      },
      asthma: {
        required,
      },
      observations: {
        required,
      },
      evolution_summary: {
        required,
      },
      doctor_name: {
        required,
      },
      medical_record: {
        required,
      },
      doctor_name2: {
        required,
      },
      medical_record2: {
        required,
      },
      medical_signature: {
        required,
      },
      medical_signature2: {
        required,
      },
      header_file: {
        required,
      },
      conduct: {
        required,
      },
      medical_plan: {
        required,
      },
      general_recommendations: {
        required,
      },
      age_appropriate: {
        required,
      },
    },
  },
  methods: {
    uploadFileCodeHabitation(data) {
      const me = this;
      me.imageCodeHabilitation = data?.image;
      me.formData.header_file = data?.file;
    },
    uploadFileSignature1(data) {
      const me = this;
      me.imageFirma1 = data?.image;
      me.formData.medical_signature = data?.file;
    },
    uploadFileSignature2(data) {
      const me = this;
      me.imageFirma2 = data?.image;
      me.formData.medical_signature2 = data?.file;
    },
    async loadDiagnosticByUser() {
      const me = this;
      try {
        const { data } = await getDiagnostcByUser(me.type);

        data?.data.forEach((x) => {
          me.diagnostics.push({
            id: x.id,
            name: x.code_name,
            created_at: x.created_at,
            last_claim: x.last_claim,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadEmployee() {
      const me = this;
      try {
        const { data } = await getEmployee(me.type);
        me.employee = {
          name: data?.name,
          typeIdentification: "Cédula de ciudadanía",
          gender: data?.gender,
          identification: data?.cc,
          birthdate: data?.birthdate,
          age: data?.age,
          occupation: data?.position?.name,
          municipality: data?.site?.city?.name,
        };
      } catch (error) {
        console.log(error);
      }
    },
    async loadTypeDiagnostic() {
      const me = this;
      try {
        const { data } = await getInfoSelect("diagnostic_type");
        data?.forEach((x) => {
          me.typeDiagnostics.push({
            id: x.id,
            name: x.info,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveData() {
      const me = this;
      const formData = {
        employee_id: me.type,
        address: me.formData.address,
        education_level: me.formData.education_level,
        civil_status: me.formData.civil_status,
        phone: me.formData.phone,
        diagnostic_type: me.formData.diagnostic_type?.id,
        diagnostic_id: me.formData.diagnostic_id?.id,
        diagnostic_observation: me.formData.diagnostic_observation,
        departure_conditions: me.formData.departure_conditions,
        consult_reason: me.formData.consult_reason,
        current_disease: me.formData.current_disease,
        hypertension: me.formData.hypertension?.id === "1" ? true : false,
        asthma: me.formData.asthma?.id === "1" ? true : false,
        age_appropriate: me.formData.age_appropriate?.id === "1" ? true : false,
        observations: me.formData.observations,
        evolution_summary: me.formData.evolution_summary,
        doctor_name: me.formData.doctor_name,
        medical_record: me.formData.medical_record,
        conduct: me.formData.conduct,
        medical_plan: me.formData.medical_plan,
        general_recommendations: me.formData.general_recommendations,
        allergies: {
          has: me.formData.allergies?.has?.id === "2" ? "0" : "1",
          ...(me.formData.allergies?.description && {
            description: me.formData.allergies?.description,
          }),
        },
        diseases: {
          has: me.formData.diseases?.has?.id === "2" ? "0" : "1",
          ...(me.formData.diseases?.description && {
            description: me.formData.diseases?.description,
          }),
        },
        habits: {
          has: me.formData.habits?.has?.id === "2" ? "0" : "1",
          ...(me.formData.habits?.description && {
            description: me.formData.habits?.description,
          }),
        },
        surgeries: {
          has: me.formData.surgeries?.has?.id === "2" ? "0" : "1",
          ...(me.formData.surgeries?.description && {
            description: me.formData.surgeries?.description,
          }),
        },
        immunization: {
          has: me.formData.immunization?.has?.id === "2" ? "0" : "1",
          ...(me.formData.immunization?.description && {
            description: me.formData.immunization?.description,
          }),
        },
        orders: {
          has: me.formData.orders?.has?.id === "2" ? "0" : "1",
          ...(me.formData.orders?.description && {
            description: me.formData.orders?.description,
          }),
        },
        referrals: {
          has: me.formData.referrals?.has?.id === "2" ? "0" : "1",
          ...(me.formData.referrals?.description && {
            description: me.formData.referrals?.description,
          }),
        },
      };
      const formDataFile = new FormData();
      formDataFile.append("medical_signature", me.formData.medical_signature);
      formDataFile.append("header_file", me.formData.header_file);
      me.isBusy = true;
      try {
        const { data } = await saveHealthCondition(formData);
        await saveFiles(data?.id, formDataFile);
        me.$emit("onSuccess");
      } catch (error) {
        console.log(error);
        me.$emit("onError");
      } finally {
        me.isBusy = false;
      }
    },
    downloadPdf() {
      const me = this;
      let link = `${process.env.VUE_APP_URL_API}/v2/health-tracker/health-conditions/${me.id}/pdf-report`;
      const a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.click();
    },
  },
  mounted() {
    const me = this;
    me.loadDiagnosticByUser();
    me.loadEmployee();
    me.loadTypeDiagnostic();
  },
};
</script>

<style lang="css">
.content-form-examen {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
  text-align: left !important;
}
.content-form-examen .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
.download-template-pdf {
  border: none !important;
  background-color: transparent !important;
  color: #0056b3 !important;
  text-decoration: underline;
  padding: 0 !important;
}
</style>
